import { Injectable } from '@angular/core';
import { v4 as uuid4 } from 'uuid';
import { stringConstant } from './stringConstants';
import { SharedService } from './shared.service';
import { RequestIdDto } from '../models/shared.model';

@Injectable({
  providedIn: 'root',
})
export class UuidService {
  public readonly constant: typeof stringConstant;

  /**
   * Constructor
   */
  constructor(private sharedService: SharedService) {
    this.constant = stringConstant;
  }
  /**
   * Method for generate the unique id of the user
   * @returns unique id
   */
  generateUuid(): string {
    return uuid4();
  }

  /**
   * Method for get and store the request id data in the local storage
   * @param data : data of the full judgement pdf
   * @returns data of the requested data
   */
  getRequestIdDataByLocalStorage(data: RequestIdDto): RequestIdDto {
    const requestLocalData = this.sharedService.getLocalStorage(
      this.constant.rqst
    );
    let requestData: RequestIdDto[] = [];

    if (requestLocalData) {
      requestData = JSON.parse(requestLocalData);

      const requestDataAvailable = requestData.find(
        (request) =>
          request.fileName === data.fileName && request.type === data.type
      );

      // If file name and type of the api is not same then store the request id in the local storage other wise provide the same request id for the api
      if (!requestDataAvailable) {
        data.rqstId = this.generateUuid();
        const obj = {
          fileName: data.fileName ? data.fileName : '',
          rqstId: data.rqstId,
          type: data.type,
        };
        requestData.push(obj);

        this.sharedService.setLocalStorage(
          this.constant.rqst,
          JSON.stringify(requestData)
        );
      } else {
        data.rqstId = requestDataAvailable.rqstId;
      }
    } else {
      data.rqstId = this.generateUuid();
      const obj = {
        fileName: data.fileName ? data.fileName : '',
        rqstId: data.rqstId,
        type: data.type,
      };
      requestData.push(obj);

      this.sharedService.setLocalStorage(
        this.constant.rqst,
        JSON.stringify(requestData)
      );
    }

    return data;
  }
}
